import ArrowIcon from '../../symbols/arrow.svg';
import ArrowLeftIcon from '../../symbols/arrow-left.svg';
import CrossIcon from '../../symbols/cross.svg';
import SearchIcon from '../../symbols/search.svg';

const config = {
    loop: true,
    backFocus: false,
    btnTpl: {
        zoom:
            '<button data-fancybox-zoom class="fancybox-button fancybox-button--zoom" title="{{ZOOM}}">' +
            `<div><svg class="icon"><use xlink:href="${SearchIcon.url}"></use></svg></div>` +
            "</button>",

        close:
            '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
            `<div><svg class="icon"><use xlink:href="${CrossIcon.url}"></use></svg></div>` +
            "</button>",
        arrowLeft:
            '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
            `<div><svg class="icon icon--reversed"><use xlink:href="${ArrowLeftIcon.url}"></use></svg></div>` +
            "</button>",

        arrowRight:
            '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
            `<div><svg class="icon"><use xlink:href="${ArrowIcon.url}"></use></svg></div>` +
            "</button>",
    }
};

export default config;
